import { On3IconLock, On3IconSoftballLogoFull } from '@on3/icons';
import clsx from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/router';

import styles, { newGreen } from './Paywall.module.scss';

type PaywallSportTypes = 'softball';
const siteIdMappings: { [key in PaywallSportTypes]: string } = {
  softball: 'softball',
};
const siteNameMappings: { [key in PaywallSportTypes]: string } = {
  softball: 'Softball America',
};
const siteIconMappings: { [key in PaywallSportTypes]: JSX.Element } = {
  softball: <On3IconSoftballLogoFull height={36} width={80} />,
};

interface PaywallProps {
  title?: string;
  className?: string;
}
export const Paywall = ({ title, className }: PaywallProps) => {
  const router = useRouter();
  const { asPath, query } = router;
  const { sport, year } = query;
  const verifiedSiteID = siteIdMappings[sport as PaywallSportTypes];
  const verifiedSiteName = siteNameMappings[sport as PaywallSportTypes];
  const utmCampaign = `${year}_${verifiedSiteID}_rankings`;
  const utmSource = `${verifiedSiteID}_rankings`;
  const joinLink = `/${verifiedSiteID}/join/`;

  const getUtmLink = (): string => {
    const params = new URLSearchParams({
      utm_source: utmSource,
      utm_medium: 'web',
      utm_campaign: utmCampaign,
      utm_content: 'plans_link',
    });

    return `${joinLink}?${params}`;
  };

  return (
    <section className={clsx(styles.wrapper, className)}>
      <div className={styles.container}>
        <div className={styles.membersOnly}>
          <On3IconLock fill={newGreen} />
          <span>Members Only</span>
        </div>
        <div className={styles.block}>
          <h2>{title ? title : `Showing Top 10 ${sport} players.`}</h2>
          <p>To see the full list, subscribe now.</p>
          {siteIconMappings[sport as PaywallSportTypes]}
        </div>
        <Link className={styles.join} href={getUtmLink()}>
          View Plans
        </Link>
        <div className={styles.links}>
          <Link href={`/${verifiedSiteID}/login?returnto=${asPath}`}>
            Login
          </Link>
          or
          <Link href={`/${verifiedSiteID}/`}>
            Go to {verifiedSiteName} Home
          </Link>
        </div>
      </div>
    </section>
  );
};
